var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5ZM6.69393 7.46495C6.69393 7.01977 7.05482 6.65888 7.5 6.65888C7.94518 6.65888 8.30608 7.01977 8.30608 7.46495V11.25C8.30608 11.6952 7.94518 12.0561 7.5 12.0561C7.05482 12.0561 6.69393 11.6952 6.69393 11.25V7.46495ZM7.5 3.71495C7.05482 3.71495 6.69393 4.07585 6.69393 4.52103C6.69393 4.96621 7.05482 5.3271 7.5 5.3271C7.94518 5.3271 8.30608 4.96621 8.30608 4.52103C8.30608 4.07585 7.94518 3.71495 7.5 3.71495Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f4680ff3f6d43bbb2a7718e7186f1b59.svg";
export { ForwardRef as ReactComponent };